export const truncateText = (words, limit, startIndex, endLength) => {
  if (words.length > limit ) {
    return `${words.substring(startIndex,endLength)}...` ;
  } 
    return words;
  
};